// BidForge brand mark — a shield-forge emblem combining government (shield) + tech (upward chevron / circuit lines).
// Sharp geometry, monochrome cyan, no gradients. Sits on dark backgrounds.

export default function Logo({ className = "w-8 h-8", strokeWidth = 1.5 }) {
  return (
    <svg
      viewBox="0 0 40 40"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="BidForge"
    >
      {/* Outer shield — 5-point tactical badge */}
      <path
        d="M20 2 L36 8 V22 C36 30 28.5 36 20 38 C11.5 36 4 30 4 22 V8 Z"
        fill="#00E5FF"
        opacity="0.08"
      />
      <path
        d="M20 2 L36 8 V22 C36 30 28.5 36 20 38 C11.5 36 4 30 4 22 V8 Z"
        fill="none"
        stroke="#00E5FF"
        strokeWidth={strokeWidth}
        strokeLinejoin="miter"
      />
      {/* Circuit-node dots at the shield corners — subtle tech accent */}
      <circle cx="4" cy="8" r="1.2" fill="#00E5FF" />
      <circle cx="36" cy="8" r="1.2" fill="#00E5FF" />
      <circle cx="20" cy="38" r="1.2" fill="#00E5FF" />
      {/* Interior chevron stack — "forge" mark; three ascending chevrons = elevation, momentum */}
      <path
        d="M12 24 L20 16 L28 24"
        fill="none"
        stroke="#00E5FF"
        strokeWidth={strokeWidth + 0.5}
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
      <path
        d="M12 30 L20 22 L28 30"
        fill="none"
        stroke="#00E5FF"
        strokeWidth={strokeWidth + 0.5}
        strokeLinecap="square"
        strokeLinejoin="miter"
        opacity="0.55"
      />
      {/* Base bar — horizontal stripe for "federal" institutional feel */}
      <line
        x1="12"
        y1="12"
        x2="28"
        y2="12"
        stroke="#00E5FF"
        strokeWidth={strokeWidth - 0.2}
      />
    </svg>
  );
}

// Compact monochrome variant for dark chips
export function LogoMark({ className = "w-6 h-6" }) {
  return <Logo className={className} strokeWidth={1.75} />;
}
